import React from 'react'

const CrowdfundSetup = ({ crowdfundSetupUrl }) =>
  <p className="widget-content p-3 p-sm-4 mb-0 text-muted">
    In order to receive donations for your event, you must create a free account
    with Pledge and connect your bank account.{' '}
    <a href={crowdfundSetupUrl} target="_blank">Create your account!</a>
  </p>

export default CrowdfundSetup
